import React, { useEffect } from 'react';

const LoadingDots = () => {
  useEffect(() => {
    // Global style ekle
    const style = document.createElement('style');
    style.textContent = `
      @keyframes loadingDot {
        0% {
          width: 0;
          height: 0;
          opacity: 0;
        }
        40% {
          width: 60%;
          height: 60%;
          opacity: 1;
        }
          50%{
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        60% {
          width: 60%;
          height: 60%;
          opacity: 1;
        }
        100% {
          width: 0;
          height: 0;
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className="text-white text-xl font-normal">Loading</div>
      <div className="flex items-center gap-2">
        {[0, 1, 2, 3, 4].map((index) => (
          <div
            key={index}
            className="w-3 h-3 rounded-full border-1 border-white bg-white relative flex items-center justify-center"
          >
            <div
              className="rounded-full bg-blue-400"
              style={{
                animation: `loadingDot 3.5s ease-in-out infinite`,
                animationDelay: `${index * 0.3}s`,
                margin: 'auto',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingDots;

